import { render, staticRenderFns } from "./ConsentContent.vue?vue&type=template&id=ed5d71c2&scoped=true&"
import script from "./ConsentContent.vue?vue&type=script&lang=js&"
export * from "./ConsentContent.vue?vue&type=script&lang=js&"
import style0 from "./ConsentContent.vue?vue&type=style&index=0&id=ed5d71c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5d71c2",
  null
  
)

export default component.exports